<template>
  <div class="container" @click="flagOn">
    <section id="editContent" class="columnContainer amenity">
      <div class="innerColumn">
        <h1 class="contentTitle">{{locale.amenity}}</h1>
        <AmenityList
          :locale="locale"
          :list="list" />
      </div>
      <div class="innerSide"><div class="sideBox">
        <AmenityFilter
          :locale="locale" />
      </div></div>
    </section>
    <div id="setContent">
      <AmenitySetting
        :locale="locale" />
    </div>
  </div>
</template>

<script>
import AmenityFilter from '@/components/Amenity/Filter.vue'
import AmenityList from '@/components/Amenity/List.vue'
import AmenitySetting from '@/components/Amenity/Setting.vue'

export default {
  name: 'Amenity',
  props: [
    'locale'
  ],
  components: {
    AmenityFilter,
    AmenityList,
    AmenitySetting
  },
  computed: {
    list () {
      return this.$store.getters['amenity/getList']
    }
  },
  created () {
    /*
    window.addEventListener('beforeunload', (e) => {
        if (this.dirtyFlag) {
          e.returnValue = '\\o/'
        }
    })
    */
    this.$store.commit('onLoading', true)
    this.$store.dispatch('amenity/getAmenity').then(() => {
      setTimeout(() => {
        this.$store.commit('onLoading', false)
      }, 2000)
    })
  },
  mounted () {
  },
  data () {
    return {
      dirtyFlag: false
    }
  },
  methods: {
    flagOn () {
      this.dirtyFlag = true
    }
  }
}
</script>
